/* Javascript developed by Designers Friend Ltd. */;

const observe_pictures = function() {

    const pictures = document.querySelectorAll('.DF__lazy')

    const options = {
        root: null,
        threshold: 0,
        rootMargin: '10%'
    }

    const observer = new IntersectionObserver(function(entries,observer){

        entries.forEach(entry => {

            if (!entry.isIntersecting){
                return false;
            }

            let picture = entry.target

            for (const child of picture.children) {
                if (child.tagName.toLowerCase() == 'source' && child.dataset.srcset.length){
                    child.setAttribute('srcset',child.dataset.srcset)
                }
            }
            
            picture.classList.add('loaded')
            observer.unobserve(picture)
     
        })

    }, options)

    pictures.forEach(picture => {
        observer.observe(picture)
    })

    this.disconnect = () =>{
        observer.disconnect()
    }
};



const observe_plxs = function() {

    const plxs = document.querySelectorAll('.plx')

    const options = {
        root: null,
        threshold: 0,
        rootMargin: '10%'
    }

    const observer = new IntersectionObserver(function(entries,observer){

        entries.forEach(entry => {

            if (!entry.isIntersecting){
                return false;
            }

            let plx = entry.target


            plx.classList.add('loaded')
            observer.unobserve(plx)
     
        })

    }, options)

    plxs.forEach(plx => {
        observer.observe(plx)
    })

    this.disconnect = () =>{
        observer.disconnect()
    }
};